const PendingIconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M8 0.5C10.1217 0.5 12.1566 1.34285 13.6569 2.84315C15.1571 4.34344 16 6.37827 16 8.5C16 10.6217 15.1571 12.6566 13.6569 14.1569C12.1566 15.6571 10.1217 16.5 8 16.5C5.87827 16.5 3.84344 15.6571 2.34315 14.1569C0.842855 12.6566 0 10.6217 0 8.5C0 6.37827 0.842855 4.34344 2.34315 2.84315C3.84344 1.34285 5.87827 0.5 8 0.5ZM8 2.5C6.4087 2.5 4.88258 3.13214 3.75736 4.25736C2.63214 5.38258 2 6.9087 2 8.5C2 10.0913 2.63214 11.6174 3.75736 12.7426C4.88258 13.8679 6.4087 14.5 8 14.5C9.5913 14.5 11.1174 13.8679 12.2426 12.7426C13.3679 11.6174 14 10.0913 14 8.5C14 6.9087 13.3679 5.38258 12.2426 4.25736C11.1174 3.13214 9.5913 2.5 8 2.5ZM7 4.5H8.5V8.28L10.83 10.61L9.77 11.67L7 8.9V4.5Z"
      //fill="#0A7593"
      className={className}
    />
  </svg>
);

const ApprovedIconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M8 0.5C3.58333 0.5 0 4.08333 0 8.5C0 12.9167 3.58333 16.5 8 16.5C12.4167 16.5 16 12.9167 16 8.5C16 4.08333 12.4167 0.5 8 0.5ZM12.1167 6.56667L7.41667 11.2833C7.26667 11.4333 7.05 11.5333 6.83333 11.5333C6.61667 11.5333 6.4 11.45 6.25 11.2833L3.88333 8.91667C3.55 8.58333 3.55 8.06667 3.88333 7.73333C4.21667 7.4 4.73333 7.4 5.06667 7.73333L6.83333 9.5L10.95 5.38333C11.2833 5.05 11.8 5.05 12.1333 5.38333C12.45 5.71667 12.45 6.23333 12.1167 6.56667Z"
      //fill="#007E33"
      className={className}
    />
  </svg>
);

const DeniedIconSVG = ({ className, parentClassName }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      d="M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5ZM10.9536 11.5393L9.775 11.5339L8 9.41786L6.22679 11.5321L5.04643 11.5375C4.96786 11.5375 4.90357 11.475 4.90357 11.3946C4.90357 11.3607 4.91607 11.3286 4.9375 11.3018L7.26071 8.53393L4.9375 5.76786C4.91592 5.74169 4.90395 5.70892 4.90357 5.675C4.90357 5.59643 4.96786 5.53214 5.04643 5.53214L6.22679 5.5375L8 7.65357L9.77321 5.53929L10.9518 5.53393C11.0304 5.53393 11.0946 5.59643 11.0946 5.67679C11.0946 5.71071 11.0821 5.74286 11.0607 5.76964L8.74107 8.53572L11.0625 11.3036C11.0839 11.3304 11.0964 11.3625 11.0964 11.3964C11.0964 11.475 11.0321 11.5393 10.9536 11.5393Z"
      //fill="#CC0000"
      className={className}
    />
  </svg>
);

export { PendingIconSVG, ApprovedIconSVG, DeniedIconSVG };
